import {
  CourseMemberIcon,
  LogoutIcon,
  MemberListIcon,
} from "@root/assets/icons";
import {
  HomeIcon,
  CourseIcon,
  myLearningIcon,
  CustomerCenterIcon,
  NoticeIcon,
  CategoryManagementIcon,
  TrainingAnnoucementIcon,
} from "@root/assets/icons";

import { LANGUAGE, ROUTE_NAMES, USER_TYPES } from "@root/constants";
import useCustomTheme from "@root/hooks/useCustomTheme";
import useMediaQ from "@root/hooks/useMediaQ";
import {
  getLoggedInUser,
  selectChatsdownStatus,
} from "@root/store/selectors/entities";
import {
  changePasswordAccount,
  deleteAccount,
  logout,
} from "@root/store/thunks";
import { useEffect, useMemo, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useLanguage from "./useLanguage";
import { updateLanguage } from "@root/store/slices/features";
import { changeAppLanguage } from "@root/utils/change-language";

function useSidebar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const chatsDropdownStatus: boolean = useSelector(selectChatsdownStatus);
  const [isOpen, setisOpen] = useState(false);
  const { lg } = useMediaQ();
  const { isDarkTheme } = useCustomTheme();
  const { id } = useParams();
  const { pathname } = useLocation();
  const { handleUpdateLanguage, currentLanguage } = useLanguage();
  const chatContext: allAnyTypes = {};
  const setCurrentMessageResponse = chatContext?.setCurrentMessageResponse;
  const getInitialThreads = chatContext?.getInitialThreads;

  const [logoutPopup, setLogoutPopup] = useState(false);
  const [deleteAccountPopup, setDeleteAccountPopup] = useState(false);
  const [changePasswordPopup, setChangePasswordPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const profileData = {};
  const isLoggedInUser: any = useSelector(getLoggedInUser);
  console.log("isLoggedInUser", isLoggedInUser);
  const { t } = useTranslation("common");
  // TODO: For testing
  const isSubscriber = false;

  const getInitialData = useCallback(() => {}, [dispatch]);

  useEffect(() => {
    getInitialData();
    if (getInitialThreads) {
      getInitialThreads();
    }
  }, [getInitialData, getInitialThreads]);

  const sidebar = useMemo(() => {
    if (isLoggedInUser?.role === USER_TYPES?.SUBSCRIBER) {
      return [
        {
          text: t("dashboard.title"),
          active: false,
          iconComponent: HomeIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_DASHBOARD),
          routes: [ROUTE_NAMES.PLEDGE_DASHBOARD],
        },
        {
          text: t("manageCourses.title"),
          active: false,
          iconComponent: CourseMemberIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_COURSES),
          routes: [ROUTE_NAMES.PLEDGE_COURSES],
        },
        {
          text: t("AdminSidebar.journalistApprovalRequest"),

          active: false,
          iconComponent: CategoryManagementIcon,
          onClick: () => navigate(ROUTE_NAMES.JOURNALIST_MANAGEMENT),
          routes: [ROUTE_NAMES.JOURNALIST_MANAGEMENT],
        },
        {
          text: t("AdminSidebar.journalist"),

          active: false,
          iconComponent: MemberListIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_JOURNALIST_LIST),
          routes: [ROUTE_NAMES.PLEDGE_JOURNALIST_LIST],
        },

        {
          text: t("notice.notices"),
          active: false,
          iconComponent: NoticeIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_ALL_NOTICES),
          routes: [ROUTE_NAMES.PLEDGE_ALL_NOTICES],
        },
        {
          text: t("AdminSidebar.Department"),
          active: false,
          iconComponent: CategoryManagementIcon,
          onClick: () => navigate(ROUTE_NAMES.DEPARTMENT_MANAGEMENT),
          routes: [ROUTE_NAMES.DEPARTMENT_MANAGEMENT],
        },
        {
          text: t("AdminSidebar.subSubscriberManagement"),
          active: false,
          iconComponent: CategoryManagementIcon,
          onClick: () => navigate(ROUTE_NAMES.SUB_SUBSCRIBER_MANAGEMENT),
          routes: [ROUTE_NAMES.SUB_SUBSCRIBER_MANAGEMENT],
        },
      ];
    }
    if (isLoggedInUser?.role === USER_TYPES?.SUBSUBSCRIBER) {
      return [
        {
          text: t("dashboard.title"),
          active: false,
          iconComponent: HomeIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_DASHBOARD),
          routes: [ROUTE_NAMES.PLEDGE_DASHBOARD],
        },
        {
          text: t("manageCourses.title"),
          active: false,
          iconComponent: CourseMemberIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_COURSES),
          routes: [ROUTE_NAMES.PLEDGE_COURSES],
        },
        {
          text: t("AdminSidebar.journalistApprovalRequest"),

          active: false,
          iconComponent: CategoryManagementIcon,
          onClick: () => navigate(ROUTE_NAMES.JOURNALIST_MANAGEMENT),
          routes: [ROUTE_NAMES.JOURNALIST_MANAGEMENT],
        },
        {
          text: t("AdminSidebar.journalist"),

          active: false,
          iconComponent: MemberListIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_JOURNALIST_LIST),
          routes: [ROUTE_NAMES.PLEDGE_JOURNALIST_LIST],
        },

        {
          text: t("notice.notices"),
          active: false,
          iconComponent: NoticeIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_ALL_NOTICES),
          routes: [ROUTE_NAMES.PLEDGE_ALL_NOTICES],
        },
        {
          text: t("AdminSidebar.Department"),
          active: false,
          iconComponent: CategoryManagementIcon,
          onClick: () => navigate(ROUTE_NAMES.DEPARTMENT_MANAGEMENT),
          routes: [ROUTE_NAMES.DEPARTMENT_MANAGEMENT],
        },
      ];
    }
    if (isLoggedInUser?.role === USER_TYPES?.NON_SUBSCRIBER) {
      return [
        {
          text: t("dashboard.title"),
          active: false,
          iconComponent: HomeIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_DASHBOARD),
          routes: [ROUTE_NAMES.PLEDGE_DASHBOARD],
        },
        {
          text: t("manageCourses.title"),
          active: false,
          iconComponent: CourseMemberIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_COURSES),
          routes: [ROUTE_NAMES.PLEDGE_COURSES],
        },
        // {
        //   text: t("AdminSidebar.journalistApprovalRequest"),

        //   active: false,
        //   iconComponent: CategoryManagementIcon,
        //   onClick: () => navigate(ROUTE_NAMES.JOURNALIST_MANAGEMENT),
        //   routes: [ROUTE_NAMES.JOURNALIST_MANAGEMENT],
        // },
        {
          text: t("AdminSidebar.journalist"),

          active: false,
          iconComponent: MemberListIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_JOURNALIST_LIST),
          routes: [ROUTE_NAMES.PLEDGE_JOURNALIST_LIST],
        },

        {
          text: t("notice.notices"),
          active: false,
          iconComponent: NoticeIcon,
          onClick: () => navigate(ROUTE_NAMES.PLEDGE_ALL_NOTICES),
          routes: [ROUTE_NAMES.PLEDGE_ALL_NOTICES],
        },
        {
          text: t("AdminSidebar.Department"),
          active: false,
          iconComponent: CategoryManagementIcon,
          onClick: () => navigate(ROUTE_NAMES.DEPARTMENT_MANAGEMENT),
          routes: [ROUTE_NAMES.DEPARTMENT_MANAGEMENT],
        },
      ];
    }

    if (isLoggedInUser?.role === USER_TYPES?.SUPER_ADMIN) {
      return [
        {
          text: t("dashboard.title"),
          active: false,
          iconComponent: HomeIcon,
          onClick: () => navigate(ROUTE_NAMES.SUPER_ADMIN_DASHBOARD),
          routes: [ROUTE_NAMES.SUPER_ADMIN_DASHBOARD],
        },
      ];
    }

    if (isLoggedInUser?.role === USER_TYPES?.ADMIN) {
      return [
        {
          text: t("AdminSidebar.course"),
          active: false,
          iconComponent: CourseIcon,
          onClick: () => navigate(ROUTE_NAMES.COURSE_MANAGEMENT),
          routes: [ROUTE_NAMES.COURSE_MANAGEMENT],
        },
        {
          text: t("AdminSidebar.subscriber"),
          active: false,
          iconComponent: myLearningIcon,
          onClick: () => navigate(ROUTE_NAMES.USER_SUBSCRIPTION),
          routes: [ROUTE_NAMES.USER_SUBSCRIPTION],
        },
        {
          text: t("AdminSidebar.journalist"),
          active: false,
          iconComponent: MemberListIcon,
          onClick: () => navigate(ROUTE_NAMES.ADMIN_JOURNALIST_MANAGEMENT),
          routes: [ROUTE_NAMES.ADMIN_JOURNALIST_MANAGEMENT],
        },
        {
          text: t("AdminSidebar.faq"),
          active: false,
          iconComponent: CustomerCenterIcon,
          onClick: () => navigate(ROUTE_NAMES.FAQS),
          routes: [ROUTE_NAMES.FAQS],
        },
        {
          text: t("AdminSidebar.notices"),
          active: false,
          iconComponent: NoticeIcon,
          onClick: () => navigate(ROUTE_NAMES.ADMIN_NOTICE),
          routes: [ROUTE_NAMES.ADMIN_NOTICE],
        },
        {
          text: t("AdminSidebar.category"),
          active: false,
          iconComponent: CategoryManagementIcon,
          onClick: () => navigate(ROUTE_NAMES.CATEGORY_MANAGEMENT),
          routes: [ROUTE_NAMES.CATEGORY_MANAGEMENT],
        },
      ];
    }

    if (isLoggedInUser?.role === USER_TYPES?.JOURNALIST) {
      return [
        {
          text: t("dashboard.title"),
          active: false,
          iconComponent: HomeIcon,
          onClick: () => navigate(ROUTE_NAMES.DASHBOARD),
          routes: [ROUTE_NAMES.DASHBOARD],
        },
        {
          text: t("courses.title"),
          active: false,
          iconComponent: CourseIcon,
          onClick: () => navigate(ROUTE_NAMES.JOURNALIST_COURSES),
          routes: [ROUTE_NAMES.JOURNALIST_COURSES],
        },
        {
          text: t("myLearning.title"),
          active: false,
          iconComponent: myLearningIcon,
          onClick: () => navigate(ROUTE_NAMES.JOURNALIST_LEARNING),
          routes: [ROUTE_NAMES.JOURNALIST_LEARNING],
        },
        {
          text: t("customerCenter.title"),
          active: false,
          iconComponent: CustomerCenterIcon,
          onClick: () => navigate(ROUTE_NAMES.JOURNALIST_CUSTOMER_CENTER),
          routes: [ROUTE_NAMES.JOURNALIST_CUSTOMER_CENTER],
        },
        {
          text: t("notice.title"),
          active: false,
          iconComponent: NoticeIcon,
          onClick: () => navigate(ROUTE_NAMES.JOURNALIST_NOTICE),
          routes: [ROUTE_NAMES.JOURNALIST_NOTICE],
        },
      ];
    }

    if (isLoggedInUser === null) {
      return [
        {
          text: t("dashboard.title"),
          active: false,
          iconComponent: HomeIcon,
          onClick: () => navigate(ROUTE_NAMES.HOME),
          routes: [ROUTE_NAMES.HOME],
        },
        {
          text: t("dashboard.video"),
          active: false,
          iconComponent: CourseIcon,
          onClick: () => navigate(ROUTE_NAMES.UNAUTHENTICATED_COURSES),
          routes: [ROUTE_NAMES.UNAUTHENTICATED_COURSES],
        },
        {
          text: t("notice.title"),
          active: false,
          iconComponent: NoticeIcon,
          onClick: () => navigate(ROUTE_NAMES.UNAUTHENTICATED_NOTICE),
          routes: [ROUTE_NAMES.UNAUTHENTICATED_NOTICE],
        },
      ];
    }

    return [];
  }, [isLoggedInUser?.role, navigate, t]);

  const menuItemsList = [
    {
      title: t("AdminSidebar.logout"),
      icon: LogoutIcon({ rotate: "180deg" }),
      onClick: () => setLogoutPopup(true),
      routes: [],
    },
  ];

  const languages = [
    {
      title: "English",
      onClick: () => handleUpdateLanguage(LANGUAGE.ENGLISH),
      isActive: currentLanguage === LANGUAGE.ENGLISH,
    },
    {
      title: "Korean",
      onClick: () => handleUpdateLanguage(LANGUAGE.KOREAN),
      isActive: currentLanguage === LANGUAGE.KOREAN,
    },
  ];

  const clickOnAdd = () => {
    if (setCurrentMessageResponse) {
      setCurrentMessageResponse(null);
    }
    navigate(ROUTE_NAMES.DASHBOARD);
  };

  const clickOnCollapseArrow = (e: any) => {
    e.stopPropagation();
  };
  const clickOnCollapse = () => {};
  const logoutHandler = () => {
    const currentRole = isLoggedInUser?.role;
    dispatch(logout({}));
    changeAppLanguage(LANGUAGE.KOREAN);
    dispatch(updateLanguage(LANGUAGE.KOREAN));
    if (currentRole === USER_TYPES.SUPER_ADMIN) {
      navigate(ROUTE_NAMES.SUPER_ADMIN_LOGIN);
    } else if (currentRole === USER_TYPES.ADMIN) {
      navigate(ROUTE_NAMES.ADMIN_LOGIN);
    } else if (currentRole === USER_TYPES.JOURNALIST) {
      navigate(ROUTE_NAMES.JOURNALIST_LOGIN);
    } else if (
      currentRole === USER_TYPES.SUBSCRIBER ||
      currentRole === USER_TYPES.SUBSUBSCRIBER ||
      currentRole === USER_TYPES.NON_SUBSCRIBER
    ) {
      navigate(ROUTE_NAMES.PLEDGE_LOGIN);
    } else {
      navigate(ROUTE_NAMES.JOURNALIST_LOGIN); // fallback
    }
  };

  const deleteUserAccount = () => {
    setLoading(true);
    dispatch(
      deleteAccount({
        onSuccess: () => {
          setLoading(false);
          logoutHandler();
        },
      })
    );
  };

  const changePasswordUserAccount = (payload: any) => {
    setLoading(true);
    dispatch(
      changePasswordAccount({
        payload,
        onSuccess: () => {
          setLoading(false);
          setChangePasswordPopup(false);
        },
        onError: () => {
          setLoading(false);
        },
      })
    );
  };

  useEffect(() => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [chatsDropdownStatus, pathname, currentLanguage]);

  return {
    isOpen,
    isDarkTheme,
    setisOpen,
    lg,
    navigate,
    dispatch,
    sidebar,
    pathname,
    chatsDropdownStatus,
    languages,
    menuItemsList,
    chatId: id,
    clickOnAdd,
    clickOnCollapseArrow,
    clickOnCollapse,
    profileData,
    logoutPopup,
    setLogoutPopup,
    deleteAccountPopup,
    setDeleteAccountPopup,
    changePasswordPopup,
    setChangePasswordPopup,
    logoutHandler,
    deleteUserAccount,
    changePasswordUserAccount,
    loading,
    setLoading,
    t,
    isMenuOpen,
    setIsMenuOpen,
  };
}

export default useSidebar;
